(function () {
  'use strict';

  function initCarousel(carousel) {
    if (carousel.dataset.klampetReady === 'true') return;

    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-klampet-slide]'));
    var previous = carousel.querySelector('[data-klampet-previous]');
    var next = carousel.querySelector('[data-klampet-next]');
    var status = carousel.querySelector('[data-klampet-status]');
    var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-klampet-dot]'));
    var index = 0;
    var pointerStartX = null;
    var pointerStartY = null;
    var wheelLocked = false;
    var autoAdvanceTimer = null;
    var autoAdvanceDelay = 10000;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!slides.length) return;

    carousel.dataset.klampetReady = 'true';
    carousel.dataset.slideCount = String(slides.length);
    carousel.classList.add('is-enhanced');

    function scheduleAdvance() {
      if (autoAdvanceTimer) window.clearTimeout(autoAdvanceTimer);
      autoAdvanceTimer = null;
      if (reduceMotion || slides.length < 2 || document.hidden) return;
      autoAdvanceTimer = window.setTimeout(function () {
        showSlide(index + 1, false);
      }, autoAdvanceDelay);
    }

    function showSlide(nextIndex, shouldFocus) {
      index = (nextIndex + slides.length) % slides.length;

      slides.forEach(function (slide, slideIndex) {
        var isActive = slideIndex === index;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        slide.querySelectorAll('a, button, input, select, textarea').forEach(function (control) {
          if (isActive) {
            control.removeAttribute('tabindex');
          } else {
            control.setAttribute('tabindex', '-1');
          }
        });
      });

      if (status) status.textContent = String(index + 1) + ' / ' + String(slides.length);
      dots.forEach(function (dot, dotIndex) {
        var isActive = dotIndex === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
      if (shouldFocus) slides[index].focus({ preventScroll: true });
      scheduleAdvance();
    }

    if (previous) previous.addEventListener('click', function () { showSlide(index - 1, false); });
    if (next) next.addEventListener('click', function () { showSlide(index + 1, false); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        showSlide(Number(dot.dataset.klampetDot), false);
      });
    });

    carousel.addEventListener('pointerdown', function (event) {
      if (event.target.closest('.klampet-hero-carousel__controls')) return;
      pointerStartX = event.clientX;
      pointerStartY = event.clientY;
      carousel.classList.add('is-dragging');
      if (carousel.setPointerCapture) carousel.setPointerCapture(event.pointerId);
    });

    carousel.addEventListener('pointerup', function (event) {
      if (pointerStartX === null) return;

      var deltaX = event.clientX - pointerStartX;
      var deltaY = event.clientY - pointerStartY;
      pointerStartX = null;
      pointerStartY = null;
      carousel.classList.remove('is-dragging');

      if (Math.abs(deltaX) >= 45 && Math.abs(deltaX) > Math.abs(deltaY)) {
        showSlide(index + (deltaX < 0 ? 1 : -1), false);
      }
    });

    carousel.addEventListener('pointercancel', function () {
      pointerStartX = null;
      pointerStartY = null;
      carousel.classList.remove('is-dragging');
    });

    carousel.addEventListener('dragstart', function (event) { event.preventDefault(); });
    carousel.addEventListener('click', scheduleAdvance);

    carousel.addEventListener('wheel', function (event) {
      if (wheelLocked || Math.abs(event.deltaX) < 35 || Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
      event.preventDefault();
      wheelLocked = true;
      showSlide(index + (event.deltaX > 0 ? 1 : -1), false);
      window.setTimeout(function () { wheelLocked = false; }, 500);
    }, { passive: false });

    carousel.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showSlide(index - 1, false);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        showSlide(index + 1, false);
      }
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden && autoAdvanceTimer) {
        window.clearTimeout(autoAdvanceTimer);
        autoAdvanceTimer = null;
      } else {
        scheduleAdvance();
      }
    });

    showSlide(0, false);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-klampet-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
}());
